import {
  ISearchUps,
  IStandardAPIResponse,
  IUPSReading,
  IReadingStatus,
} from '../../vm';
import { httpClient, handleErrorResp } from '../UtilService';

export async function getUpsReadings(
  obj: ISearchUps
): Promise<IStandardAPIResponse<Array<IUPSReading>>> {
  try {
    let res = await httpClient<Array<IUPSReading>>(`ups-readings`, 'GET', obj);
    return res;
  } catch (err) {
    return handleErrorResp([]);
  }
}
export async function updateUpsReadingStatus(
  obj: IReadingStatus
): Promise<IStandardAPIResponse<any>> {
  try {
    let res = await httpClient<any>(`ups-readings/status`, 'PATCH', obj);
    return res;
  } catch (err) {
    return handleErrorResp([]);
  }
}
export async function updateUPSReading(
  obj: IUPSReading
): Promise<IStandardAPIResponse<IUPSReading>> {
  try {
    let res = await httpClient<IUPSReading>(
      `ups-readings/${obj._id}`,
      'PATCH',
      obj
    );
    return res;
  } catch (err) {
    return handleErrorResp([]);
  }
}
